import React, { useEffect } from "react";
import { Input } from "../../Helpers/Input/Input";
import PhoneInput from "react-phone-input-2";
import trans from "../../../utils";
import usePermission from "../../../hooks/usePermission";

export default function AccountProfile({ inf, setFormValidation }) {
	useEffect(() => {
		if (inf.errors.name) {
			setFormValidation(true);
		} else {
			setFormValidation(false);
		}
	}, [inf.errors, inf.values.name, setFormValidation]);
	const { edit } = usePermission("SETUPACCOUNT");

	return (
		<div className="account-layout">
			<div>
				<div className="account-layout-head">{trans("Profile")}</div>
				<p className="account-layout-title">
					{trans("Manage details of your personal profile.")}
				</p>
				<div className="row">
					<div className="col-lg-6 col-sm-12">
						<Input
							title={trans("Name")}
							type="text"
							placeholder={trans("Ex. Ahmed Ali")}
							formstyle="form-input"
							id="name"
							name="name"
							onBlur={inf.handleBlur}
							onChange={inf.handleChange}
							errors={inf.errors.name}
							touched={inf.touched.name}
							value={inf.values.name || ""}
							disabled={!edit}
						/>
						{/**<InputLanguage
							formstyle="form-input"
							id="language"
							name="language"
						/>**/}
					</div>
					<div className="col-lg-6 col-sm-12">
						<Input
							title={trans("Email")}
							type="email"
							placeholder="Ex@gmail.com"
							formstyle="form-input"
							id="email"
							name="email"
							onBlur={inf.handleBlur}
							onChange={inf.handleChange}
							errors={inf.errors.email}
							touched={inf.touched.email}
							disabled={!edit}
							value={inf.values.email || ""}
						/>
					</div>
					<div className="col-lg-6 col-sm-12">
						<div className={`position-relative form-input`}>
							<label className="form-label">{trans("phone number")}</label>
							<div dir="ltr">
								<PhoneInput
									country={"eg"}
									id="phone"
									name="phone"
									inputClass="phone-input"
									containerClass="phone-input-container"
									countryCodeEditable={false}
									enableSearch={true}
									disableSearchIcon
									onBlur={inf.handleBlur}
									onChange={(value) => inf.setFieldValue("phone", value)}
									disabled={!edit}
									value={inf.values.phone || ""}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
